








import Component from 'vue-class-component'
import Dashboard from '@/components/dashboard/Dashboard.component'
import {Action, Getter, Mutation} from 'vuex-class'
import BaseComponent from './base/BaseComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {CompanyDetailsResponse, IsAuthorizedForPageRequest, Utils} from '@payroll/optimus-common'
import FooterBar from '@/components/dashboard/footer/Footer.component'

const variables = require('@/assets/styles/_variables.scss')

@Component({
    components: {
        Dashboard,
        FooterBar
    }
})
export default class App extends BaseComponent {
    private lang: string = ''
    private isAuthorizedForPageRequest: IsAuthorizedForPageRequest = {
        pageName: ''
    } as IsAuthorizedForPageRequest

    @Action('isAuthorizedForPage', StoreNamespace.AUTHENTICATION) isAuthorizedForPage: any
    @Action('resetStore') resetStore: any
    @Mutation('setAuthorizedPage', StoreNamespace.AUTHENTICATION) setAuthorizedPage: any
    @Getter('authorizedPages', StoreNamespace.AUTHENTICATION) authorizedPages!: string[]
    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

    private readonly nodeEnv: any = process.env.NODE_ENV

    mounted() {
        if (!Utils.isCompatibleBrowser()) {
            this.$router.push({name: 'compatibility'})
        }

        this.lang = '' + this.$t('lang')
        document.getElementsByTagName("body")[0].setAttribute("dir", '' + this.$t('dir'));

        if (this.mngCompanyName) {
            this.$Progress.setColor(variables[this.mngCompanyName + '-secondary'])
        }
        this.$Progress.finish()

        if (this.nodeEnv === 'production') {
            let googleAnalyticsManagerScript = document.createElement('script')
            googleAnalyticsManagerScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + this.customerDetails.analyticsSiteId)
            googleAnalyticsManagerScript.setAttribute('async', 'true')
            document.head!.appendChild(googleAnalyticsManagerScript)

            let googleAnalyticsScript = document.createElement('script')

            googleAnalyticsScript.innerHTML = "window.dataLayer = window.dataLayer || [];\n" +
                "        function gtag(){dataLayer.push(arguments);}\n" +
                "        gtag('js', new Date());\n" +
                "\n" +
                "        gtag('config','" + this.customerDetails.analyticsSiteId + "');"

            document.head!.appendChild(googleAnalyticsScript)
        }
    }

    created() {
        this.$Progress.start()

        this.$router.beforeEach((to, from, next) => {
            if (this.mngCompanyName) {
                this.$Progress.setColor(variables[this.mngCompanyName + '-secondary'])
            }
            this.$Progress.start()

            if (to.matched.some(record => record.meta.windowRedirectAfter)) {
                window.location.hash = to.fullPath
                window.location.reload(true)
                return
            } else if (to.matched.some(record => record.meta.authNotRequired || record.meta.noAuthPageCheck)) {
                next()
                if (to.matched.some(record => record.meta.resetStore)) {
                    this.resetStore()
                }
            } else if (this.accessToken) {
                let pageName: string = to.name === undefined ? '' : to.name
                if (this.authorizedPages.indexOf(pageName) > -1) {
                    next()
                } else {
                    this.isAuthorizedForPageRequest.pageName = pageName
                    this.isAuthorizedForPage({
                        requestorCallback: this,
                        requestBody: this.isAuthorizedForPageRequest
                    })
                }
            } else {
                next({name: 'session-timeout'})
            }
        })

        this.$router.afterEach(() => this.$Progress.finish())
    }

    get showHeaderAndMenu(): boolean {
        return !this.$route.meta.authNotRequired && !this.$route.meta.hideHeaderAndMenu
    }

    onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
        this.setAuthorizedPage({pageName: this.isAuthorizedForPageRequest.pageName, isAuthorized: true})
        this.$router.push({name: this.isAuthorizedForPageRequest.pageName})
    }

    onError(messages: string[], code: number, requestName?: string): void {
        this.setAuthorizedPage({pageName: this.isAuthorizedForPageRequest.pageName, isAuthorized: false})
        this.$router.push({name: 'unauthorized'})
    }
}
